// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t06s0zIdRzKC55 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-025, 2px) var(--ds-space-0, 2px);
}
`, ""]);
// Exports
export var iconWrapper = `t06s0zIdRzKC55`;
export default ___CSS_LOADER_EXPORT___;
